import BaseModal from '@/components/BaseModal';
import { PreviewVideoStyled } from '@/components/PreviewVideo/styled';
import { IconSource, MediaCard, VideoThumbnail } from '@shopify/polaris';
import { ExternalIcon, PlayCircleIcon } from '@shopify/polaris-icons';
import { useState } from 'react';

interface IProps {
  title: string;
  description: string;
  videoUrl: string;
  videoLength: number;
  thumbnailUrl: string;
  primaryOnClick?: () => void;
  primaryContent?: string;
  primaryIcon?: IconSource;
}

const PreviewVideo = ({
  title,
  description,
  videoUrl,
  videoLength,
  thumbnailUrl,
  primaryOnClick,
  primaryContent,
  primaryIcon,
}: IProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const handleClickWatchVideo = () => {
    setIsOpenModal(true);
  };
  return (
    <PreviewVideoStyled className="mt-8">
      <MediaCard
        title={title}
        primaryAction={
          primaryOnClick
            ? {
                content: primaryContent || 'Read guide',
                icon: primaryIcon || ExternalIcon,
                onAction: primaryOnClick,
              }
            : undefined
        }
        secondaryAction={{
          content: 'Watch video',
          icon: PlayCircleIcon,
          onAction: handleClickWatchVideo,
        }}
        description={description}
      >
        <VideoThumbnail videoLength={videoLength} thumbnailUrl={thumbnailUrl} onClick={handleClickWatchVideo} />
      </MediaCard>

      <BaseModal
        title={title}
        open={isOpenModal}
        onClose={() => {
          setIsOpenModal(false);
        }}
        size="large"
      >
        <div>
          <iframe
            style={{ width: '100%', height: '50vh' }}
            src={videoUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={title}
          />
        </div>
      </BaseModal>
    </PreviewVideoStyled>
  );
};

export default PreviewVideo;
